import React from 'react';

import { ResumeMontant } from './ResumeMontant';
import {
    IResumeOffre,
    hasSoumissionAssurance,
    useRenouvellementApi,
    useSessionApi
} from '../../hooks';
import { getFormattedDate } from '../../utils';

export interface IResumeMontantConnectedProps {
    resumeOffre: IResumeOffre;
    isDetailAssurance?: boolean;
}

export const ResumeMontantConnected: React.FC<IResumeMontantConnectedProps> = ({
    resumeOffre,
    isDetailAssurance = true
}) => {
    const { data: session } = useSessionApi();
    const { data: renouvellement } = useRenouvellementApi(!!session);

    const isAjoutAssurance =
        renouvellement?.pretAdmissibleAssurance &&
        hasSoumissionAssurance(resumeOffre?.assurance?.codeAssurance);

    return (
        <ResumeMontant
            resumeOffre={resumeOffre}
            isAjoutAssurance={isAjoutAssurance}
            dateDuJour={new Date(getFormattedDate(session?.dateSysteme, '/'))}
            isDetailAssurance={isDetailAssurance}
        />
    );
};
